import { styled, theme } from 'stitches.config'

const accent = theme.colors['primary-800'].value

export const FeedingInfoCardRoot = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  marginTop: '$4',
  padding: '$4 $2',
  borderTop: `4px solid ${accent}`,
  boxShadow: '0 8px 40px 0 rgba(0, 0, 0, 0.10)',
})

export const Badge = styled('span', {
  alignSelf: 'flex-start',
  backgroundColor: accent,
  color: '$accent-white',
  textTransform: 'uppercase',
  fontSize: '$caption',
  letterSpacing: '0.66px',
  fontFamily: '$primary',
  fontWeight: '$medium',
  borderRadius: '$pill',
  padding: '$1 $2',
})

export const Headline = styled('h4', {
  fontFamily: '$display',
  fontWeight: '$extraLight',
  fontSize: '$h5',
  lineHeight: '30.791px',
  letterSpacing: '-0.6px',
  color: '$accent-black',
})

export const Description = styled('p', {
  fontFamily: '$primary',
  fontWeight: '$medium',
  fontSize: '$body',
  lineHeight: '26px',
  color: 'rgba(0, 0, 0, 0.70)',
})

export const CtaWrapper = styled('div', {
  marginTop: '$1',

  a: {
    display: 'block',
  },
})
